// @flow
type Fn = (...args: any[]) => any
type Store = {
  [id: string]: {
    [type: string]: Fn
  }
}

/* A very simple global store used to invoke scoped events per instance (using the root elements id as identifier) */
class GlobalEventStore {
  store: Store = {}
  dispatch = (id: string, type: string, ...values: any[]) => {
    this.store[id][type](...values)
  }
  add = (id: string, type: string, fn: Fn) => {
    if (!this.store[id]) this.store[id] = {}
    this.store[id][type] = fn
  }
}

export const globalEventStore = new GlobalEventStore()
export default globalEventStore
